import queryString from 'query-string';
import { errorToast } from '../../utils/toast';
import config from './../../components/config';

export const getUploadUrl = async (file, module, recordID, display_name) => {
  const params = {
    bucket: config.aws_bucket,
    ContentType: file?.type,
    Key: config.env + `/${module}/` + recordID + '/' + display_name,
  };
  const response = await fetch(
    `${config.baseURL}/generate-put-url?${queryString.stringify(params)}`,
    {
      headers: {
        'Content-Type': params.ContentType,
      },
    }
  );
  return response.json();
};

export const uploadFileToS3 = async (uploadUrl, file, contentType) => {
  const response = await fetch(uploadUrl.putURL, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });
  if (response.status !== 200) {
    errorToast('File upload failed.');
    throw new Error('File upload failed.');
  }
};

export const getFileUrl = (path, id, fileName) => {
  return `${config.uploaded_file_url}/${config.env}/${path}/${id}/${fileName}`;
};
